import React,{ Component } from 'react';
import {
  Row,
  Col,
  FormGroup,
  Input,
  Label
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import Button from '../../../shared/components/Button';

import { divideArrayIntoNGroups,delayPromiseChain } from '../../../shared/utils';


class ProviderCampaignPublishers extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      isSaving:false,
      error:null
    };
  }

  componentDidMount(){
    //TODO: Load data from server for ProviderCampaignPublishers in componentDidMount
    Promise
      .all([
        this.props.loadPublishersForCampaign(this.props.campaignId),
        this.props.loadRetailers()
      ])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  handleSubmit(data){
    const publisherIds = Object.keys(data.publishers || {});

    this.setState({isSaving:true});

    this.props.updatePublishersForCampaign(this.props.campaignId,publisherIds)
      .then(() => delayPromiseChain(1000))
      .then(() => this.setState({isSaving:false}));
  }

  render(){
    //TODO: Render ProviderCampaignPublishers
    return (
      <div className='ProviderCampaignPublishers'>
      {this.state.isLoaded ? (
        <Form onSubmit={(data) => this.handleSubmit(data)}>
          <Row>
            <Col xs='12'>
              <p>This campaign will reach the following publishers.</p>
            </Col>
          </Row>
          <Row>
            {divideArrayIntoNGroups(this.props.publishers,2).map((group,i) => (
              <Col md='6' key={i}>
                {group.map((publisher) => (
                  <FormGroup check key={publisher.id}>
                    <Label check>
                      <Input
                        type='checkbox'
                        name={`publishers[${publisher.id}]`}
                        defaultChecked={this.props.campaign.publisherIds.indexOf(publisher.id) >= 0}
                      />
                      &nbsp;&nbsp;{publisher.name === 'Dabbl' ? 'Downtime Dollars' : publisher.name}
                    </Label>
                  </FormGroup>
                ))}
              </Col>
            ))}
          </Row>
          <br />
          <Button
            disabled={this.state.isSaving}
            isSubmit
          >{this.state.isSaving?'Saving':'Save'}</Button>
        </Form>
      ) : (
        <span>Loading</span>
      )}
      </div>
    );
  }
}

ProviderCampaignPublishers.propTypes = {
  //TODO: Fill in prop types for ProviderCampaignPublishers
};

ProviderCampaignPublishers.defaultProps = {
  //TODO: Fill in defaultProps for ProviderCampaignPublishers
};

export default ProviderCampaignPublishers;



// WEBPACK FOOTER //
// ./src/routes/ProviderCampaignPublishers/components/ProviderCampaignPublishers.js